import proj4 from 'proj4';

/**
 * Builds one source-to-WGS84 transform for an entire import. GeoJSON-style
 * axis order remains x/y (longitude/latitude) and non-horizontal ordinates
 * are copied without claiming a vertical transformation.
 */
export function createWgs84CoordinateTransform(
  sourceDefinition: string,
): (position: readonly number[]) => number[] {
  const converter = proj4(sourceDefinition, 'WGS84');

  return (position) => {
    const x = position[0];
    const y = position[1];
    if (x === undefined || y === undefined) return [...position];

    const transformed = converter.forward([x, y]);
    const longitude = transformed[0];
    const latitude = transformed[1];
    if (longitude === undefined || latitude === undefined) return transformed;
    return [longitude, latitude, ...position.slice(2)];
  };
}
